/**
 * @file
 * Main theme JS.
 */
(function (Drupal, once, document) {
  // Responsive toggle menu handling.
  const responsiveMenuOpen = document.querySelector(".primary-menu-open");
  const responsiveMenuClose = document.querySelector(".primary-menu-close");
  const dropdownMenus = document.querySelectorAll(".block-menu details");
  responsiveMenuOpen.addEventListener("click", () => {
    document.body.classList.add("responsive-menu-open");
    document.documentElement.classList.add("responsive-menu-open");
    // Open details on drop down menu if it is closed.
    dropdownMenus.forEach((menu) => {
      if (!menu.open) {
        menu.open = true;
      }
    });
  });
  responsiveMenuClose.addEventListener("click", () => {
    document.body.classList.remove("responsive-menu-open");
    document.documentElement.classList.remove("responsive-menu-open");
  });

  /**
   * Get url anchor.
   *
   * @return {boolean}|{string}
   */
  function getURLAnchor() {
    let urlAnchor = false;
    const urlParts = document.URL.split("#");
    if (urlParts.length > 1) {
      // eslint-disable-next-line prefer-destructuring
      urlAnchor = urlParts[1];
    }
    return urlAnchor;
  }

  /**
   * Collapsible tables JS improvements.
   */
  Drupal.behaviors.vibTables = {
    attach: function attach(context) {
      const urlAnchor = getURLAnchor();

      once("vib-tables", "td.tr-expand", context).forEach((tdExpand) => {
        const tr = tdExpand.parentNode;
        const expandLink = tdExpand.children[0];

        // If row is already expanded attach expanded CSS class to it.
        if (urlAnchor && tr.id && urlAnchor === tr.id) {
          tr.classList.add("expanded");
        }

        // Support closing of expanded row.
        expandLink.addEventListener("click", (e) => {
          if (tr.classList.contains("expanded")) {
            // Removing of hash from URL will tell CSS :target selector to close
            // this row.
            window.location.hash = "";
            tr.classList.remove("expanded");
            // Prevent browser loading the same anchor again.
            e.preventDefault();
            e.stopPropagation();
          } else {
            tr.classList.add("expanded");
          }
        });
      });
    },
  };

  /**
   * Views JS improvements.
   */
  Drupal.behaviors.vibViews = {
    attach: function attach(context) {
      // Views filter open/close functionality.
      once("vib-views", ".view-filters-open-link", context).forEach(
        (openLink) => {
          const urlAnchor = openLink.href.split("#")[1];
          const targetFilter = document.querySelector(`#${urlAnchor}`);
          const closeLink = targetFilter.querySelector(".view-filters__close");

          // Remove href target so browser does not jump on link click.
          openLink.href = "#";

          // If we have browser url anchor that is pointing to this target then
          // open the target and hide open link.
          if (urlAnchor === getURLAnchor()) {
            targetFilter.classList.add("display-block");
            openLink.classList.add("display-none");
          }

          // Open link click handling.
          openLink.addEventListener("click", (e) => {
            targetFilter.classList.remove("display-none");
            targetFilter.classList.add("display-block");
            openLink.classList.add("display-none");
            e.preventDefault();
          });

          // Close link click handling.
          closeLink.addEventListener("click", (e) => {
            targetFilter.classList.remove("display-block");
            targetFilter.classList.add("display-none");
            openLink.classList.remove("display-none");
            e.preventDefault();
          });
        }
      );
    },
  };
})(Drupal, once, document);
